module.exports = __webpack_public_path__ + "static/media/Cancel_public_events_delay.444d3290.svg";